import React, { useEffect } from 'react'
import WebFont from 'webfontloader';
// eslint-disable-next-line
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import { Container, Row, Card, Button, Form, Col, Modal, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faFileImport, faArrowLeft, faFileExcel, faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import NavBar from "../navbar/Navbar";
import Fuse from 'fuse.js';
import * as XLSX from 'xlsx';

import { get, post } from '../../../controllers/endpoints.controller';
import { getUserToken, logout } from '../../../controllers/user.controller';
import { convert2Base64 } from '../../../tools/tools';


export default function ProviderToGBPCodeTranslate() {

    const [step1, setStep1] = React.useState(true);
    const [step2, setStep2] = React.useState(false);
    const [step3, setStep3] = React.useState(false);

    const [showLoading, setShowLoading] = React.useState(false);
    const handleCloseLoadingModal = () => { setShowLoading(false); };
    const handleShowLoadingModal = () => {
        setShowLoading(true);
    };

    const [excelFile, setExcelFile] = React.useState(null);
    const [excelColumns, setExcelColumns] = React.useState([]);
    const [columnProviderMapping, setColumnProviderMapping] = React.useState({});
    const [providers, setProviders] = React.useState([]);

    const PAGE_TITLE = "Vincular códigos de proveedores";
    const PAGE_ICON = faFileImport;

    useEffect(() => {
        WebFont.load({
            google: {
                families: ['Roboto:100,300,400']
            }
        });

        document.title = `4-Tech - ${PAGE_TITLE}`;

        getProviders();

    }, []);

    const getProviders = async function () {
        const req = await get(`/provider/all`, getUserToken());
        const res = await req.json();

        if (req.status === 200) {
            console.log(res)
            setProviders(res)
        } else if (req.status === 403) {
            logout();
        } else {
            alert(res.message);
        }
    }

    const getExcelColumnName = (colIndex) => {
        let columnName = '';
        let dividend = colIndex + 1;
        let modulo;

        while (dividend > 0) {
            modulo = (dividend - 1) % 26;
            columnName = String.fromCharCode(65 + modulo) + columnName;
            dividend = Math.floor((dividend - modulo) / 26);
        }

        return columnName;
    }

    const handleFileUpload = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setExcelFile(file);

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
            const range = XLSX.utils.decode_range(firstSheet['!ref']);
            
            // Obtener columnas desde E (índice 4) en adelante
            const columns = [];
            for (let col = 4; col <= range.e.c; col++) {
                const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
                const cell = firstSheet[cellAddress];
                if (cell && cell.v) {
                    columns.push({
                        index: col + 1, // Base 1 (E=5, F=6, etc.)
                        letter: getExcelColumnName(col), // A, B, ..., Z, AA, AB, ...
                        headerValue: cell.v
                    });
                }
            }
            
            setExcelColumns(columns);
            
            const initialMapping = {};
            columns.forEach(col => {
                const suggestion = findBestProviderMatch(col.headerValue);
                initialMapping[col.index] = suggestion ? suggestion.id : "";
            });
            setColumnProviderMapping(initialMapping);
        };
        reader.readAsArrayBuffer(file);
    }

    const findBestProviderMatch = (headerValue) => {
        if (!providers || providers.length === 0 || !headerValue) return null;

        const fuse = new Fuse(providers, {
            keys: ['name', 'friendlyName'],
            threshold: 0.3 // 70% de similitud (0.3 = 30% de diferencia)
        });

        const results = fuse.search(headerValue);
        return results.length > 0 ? results[0].item : null;
    }

    const handleProviderChange = (columnIndex, providerId) => {
        setColumnProviderMapping(prev => ({
            ...prev,
            [columnIndex]: providerId
        }));
    }

    const showNextStep = () => {
        if (step1) {
            setStep1(false);
            setStep2(true);
        } else if (step2) {
            setStep2(false);
            setStep3(true);
        }
    }

    const nextStep = () => {
        if (step1) {
            if (!excelFile) {
                alert("Por favor, selecciona un archivo Excel");
                return;
            }
            showNextStep();
        } else if (step2) {
            const allMapped = excelColumns.every(col => 
                columnProviderMapping[col.index] && columnProviderMapping[col.index] !== ""
            );
            
            if (!allMapped) {
                alert("Por favor, selecciona un proveedor para todas las columnas antes de continuar");
                return;
            }
            
            sendData();
        }
    }

    const sendData = async function () {
        handleShowLoadingModal();
        
        try {
            const fileBase64 = await convert2Base64(excelFile);
            const ext = excelFile.name.split('.');
            const extension = ext[ext.length - 1];

            const body = {
                Columns: columnProviderMapping,
                File: {
                    file: fileBase64,
                    ext: extension
                }
            };

            console.log("Enviando:", body);

            const req = await post(`/provider/excel/processproductcodes`, getUserToken(), body);
            const res = await req.json();

            handleCloseLoadingModal();

            if (req.status === 201) {
                console.log(res);
                showNextStep();
            } else if (req.status === 403) {
                logout();
            } else {
                alert(res.message || "Error al procesar el archivo");
            }
        } catch (error) {
            handleCloseLoadingModal();
            alert("Error al procesar el archivo: " + error.message);
        }
    }

    const getProviderName = (providerId) => {
        const provider = providers.find(p => p.id == providerId);
        return provider ? provider.friendlyName : "";
    }

    return (
        <div className='p-0' style={{ fontFamily: 'Roboto' }}>
            <style>{'body {background-color: #EBEBEB !important;}'}</style>
            <NavBar />

            <div style={{ height: 300, background: '#FAFAFA' }}>
                <Container>
                    <Row style={{ paddingTop: 10 }} className='d-none d-sm-block'>
                        <table className='w-75' style={{ marginLeft: 'auto', marginRight: 'auto' }}>
                            <tbody>
                                <tr>
                                    <td style={{ fontSize: 45, fontWeight: 300 }}>
                                        <p className='m-0' style={{ color: '#A0A0A0', fontSize: 45, fontWeight: 300 }}>{PAGE_TITLE}</p>
                                    </td>
                                    <td style={{ fontSize: 140, width: 150 }}>
                                        <FontAwesomeIcon icon={PAGE_ICON} style={{ fontSize: 140, color: "A0A0A0" }} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Row>

                    <div className='d-block d-sm-none'>
                        <Row style={{ paddingTop: 10, height: 200 }} >
                            <Col xs={6} className='align-center-vertically-v2'>
                                <p className='m-0' style={{ color: '#A0A0A0', fontSize: 35, fontWeight: 300 }}>{PAGE_TITLE}</p>
                            </Col>
                            <Col xs={6} className='align-center-vertically-v2' style={{ textAlign: 'right' }}>
                                <FontAwesomeIcon icon={PAGE_ICON} style={{ fontSize: 70, color: "A0A0A0" }} />
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>

            <Container>
                <Row style={{ marginTop: -70 }}>
                    <Card className='cards content mb-5'>
                        <Row className='content-options content'>
                            <Col className='d-none d-sm-block align-center-vertically-v2 ps-5'>
                                <Link to={'/inicio'} className='link-primary'>
                                    <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: 8 }} /><span className='me-3'>Volver al menú</span>
                                </Link>
                                {step1 ? "Paso 1 | Cargar archivo Excel" : ""}
                                {step2 ? "Paso 2 | Vincular proveedores" : ""}
                                {step3 ? "Paso 3 | Archivo importado" : ""}
                            </Col>
                            <Col className='d-none d-sm-block align-center-vertically-v2 pe-5' style={{ textAlign: 'right' }}>
                            </Col>
                        </Row>

                        {/* STEP 1: Cargar archivo Excel */}
                        <Container style={{ display: (step1 === false ? 'none' : '') }}>
                            <Row>
                                <Col>

                                </Col>
                                <Col style={{ textAlign: 'center' }} className='pt-5 pb-5'>
                                    <p className='m-0'><FontAwesomeIcon icon={faFileExcel} style={{ fontSize: 60 }}></FontAwesomeIcon></p>
                                    <p className='m-0 pt-2'>Cargá el archivo Excel con las relaciones de códigos</p>
                                    <p className='m-0 pt-4'><Form.Control accept='.xlsx, .xls' onChange={(event) => handleFileUpload(event)} type="file" /></p>
                                    <p className='m-0 pt-4' style={{ fontSize: 14, color: '#666' }}>El archivo debe contener los nombres de los proveedores a partir de la columna E</p>
                                </Col>
                                <Col>

                                </Col>
                            </Row>
                            <Row>
                                <Col style={{ textAlign: 'right' }} className='pb-3'>
                                    <Button onClick={nextStep}>Siguiente <FontAwesomeIcon icon={faArrowRight}></FontAwesomeIcon></Button>
                                </Col>
                            </Row>
                        </Container>

                        {/* STEP 2: Vincular proveedores */}
                        <Container style={{ display: (step2 === false ? 'none' : '') }}>
                            <Row>
                                <Col className='pt-5 pb-5'>
                                    <p className='mb-4' style={{ textAlign: 'center', fontSize: 18 }}>Vinculá cada columna con su proveedor correspondiente</p>
                                    
                                    {excelColumns.length === 0 ? (
                                        <p style={{ textAlign: 'center', color: '#666' }}>No se encontraron columnas con datos en la fila 1</p>
                                    ) : (
                                        <div>
                                            {excelColumns.map((col, i) => (
                                                <Row key={i} className='mt-1 p-2 mb-2' style={{ background: '#F0F0F0', borderRadius: 8 }}>
                                                    <Col xs={2} className='align-center-vertically-v2' style={{ textAlign: 'right' }}>
                                                        <strong>Columna {col.letter}</strong>
                                                    </Col>
                                                    <Col xs={3} className='align-center-vertically-v2' style={{ fontSize: 14, color: '#666' }}>
                                                        ({col.headerValue})
                                                    </Col>
                                                    <Col xs={7} className='align-center-vertically-v2'>
                                                        <Form.Select 
                                                            value={columnProviderMapping[col.index] || ""} 
                                                            onChange={(e) => handleProviderChange(col.index, e.target.value)}
                                                            style={{
                                                                borderColor: (!columnProviderMapping[col.index] || columnProviderMapping[col.index] === "") ? '#dc3545' : '',
                                                                borderWidth: (!columnProviderMapping[col.index] || columnProviderMapping[col.index] === "") ? '2px' : ''
                                                            }}
                                                        >
                                                            <option value="">Seleccionar proveedor...</option>
                                                            {providers.map((p, idx) => (
                                                                <option key={idx} value={p.id}>{p.friendlyName}</option>
                                                            ))}
                                                        </Form.Select>
                                                    </Col>
                                                </Row>
                                            ))}
                                        </div>
                                    )}
                                </Col>
                            </Row>
                            <Row>
                                <Col style={{ textAlign: 'right' }} className='pb-3'>
                                    <Button onClick={nextStep}>Confirmar <FontAwesomeIcon icon={faArrowRight}></FontAwesomeIcon></Button>
                                </Col>
                            </Row>
                        </Container>

                        {/* STEP 3: Archivo importado correctamente */}
                        <Container style={{ display: (step3 === false ? 'none' : '') }}>
                            <Row>
                                <Col>

                                </Col>
                                <Col style={{ textAlign: 'center' }} className='pt-5 pb-5'>
                                    <p className='m-0'><FontAwesomeIcon icon={faCheckCircle} style={{ fontSize: 60, color: '#28a745' }}></FontAwesomeIcon></p>
                                    <p className='m-0 pt-3' style={{ fontSize: 24, fontWeight: 300 }}>Archivo importado correctamente</p>
                                    <p className='m-0 pt-4' style={{ color: '#666' }}>Las relaciones de códigos han sido procesadas exitosamente</p>
                                    <p className='m-0 pt-5'>
                                        <Link to={'/inicio'}>
                                            <Button variant="primary">Volver al inicio</Button>
                                        </Link>
                                    </p>
                                </Col>
                                <Col>

                                </Col>
                            </Row>
                        </Container>

                    </Card>
                </Row>
            </Container>

            <Modal show={showLoading} centered backdrop="static" keyboard={false} onHide={handleCloseLoadingModal}>
                <Modal.Body style={{ textAlign: 'center' }}>
                    <Spinner className='mt-3' animation="border" />
                    <p className='mt-1 mb-3'>Procesando archivo...</p>
                </Modal.Body>
            </Modal>
        </div>
    )
}
